import { combineReducers } from 'redux';
import { createReducer } from '../utils';

const SET_ACTIVE_LOCKING_ID = 'SET_ACTIVE_LOCKING_ID';
const RESET_ACTIVE_LOCKING_ID = 'RESET_ACTIVE_LOCKING_ID';

function doSetActiveLockingId(locking) {
	return {
		type: SET_ACTIVE_LOCKING_ID,
		locking
	};
}

function doResetActiveLockingId() {
	return {
		type: RESET_ACTIVE_LOCKING_ID
	};
}

function doToggleActiveLockingId(locking) {
	return function(dispatch, getState) {
		if (!locking) {
			dispatch(doResetActiveLockingId());
		} else {
			const activeLockingId = getActiveLockingId(getState());
			const isSameLocking = locking.locking_id === activeLockingId;
			isSameLocking
				? dispatch(doResetActiveLockingId())
				: dispatch(doSetActiveLockingId(locking));
		}
	};
}

const initialState = null;

const reducer = createReducer(initialState, {
	[SET_ACTIVE_LOCKING_ID]: (state, action) => action.locking.locking_id,
	[RESET_ACTIVE_LOCKING_ID]: (state, action) => initialState,
	CLOSE_LOCKING_FORM: (state, action) => initialState
});

function getActiveLockingId(state) {
	return state.app.activeLockingId;
}

export default reducer;
export { doToggleActiveLockingId, getActiveLockingId };



// WEBPACK FOOTER //
// ./src/js/reducers/app/activeLockingId.js